<template>
    <div id="teams">
        <!--=====================================-->
        <!--=        Project Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <!-- data-sal="slide-up" data-sal-duration="1000" -->
                <div id="first-banner" class="project-add-banner">
                    <div class="content">
                        <span class="subtitle bold">Otras tecnologías</span>
                        <h3 class="font-weight-100">
                            ¿Tu negocio genera <span class="bold">impacto</span>?
                        </h3>
                        <h6 class="font-weight-100 w-75">
                            Si desarrollas, provees o brindas un servicio diferente a las tecnologías 
                            o giros señalados, pero tu trabajo tiene un impacto ambiental, 
                            ¡Te podemos ayudar! Compartenos tu interés y nos comunicamos contigo
                        </h6>
                        <button @click.stop="goToTop()" class="axil-btn btn-borderd p-4">Contáctanos</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "ContactBanner",
    components: {
    },
    methods: {
        goToTop() {
            window.location.href = "#";
        }
    }
}

</script>

<style scoped>
.project-add-banner {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/banners/banner-supplier.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    /* background: rgb(131,238,76); */
    background-color: linear-gradient(90deg, rgba(131,238,76,1) 0%, rgba(145,242,89,1) 100%);
}
</style>